import { render } from "./FormButton.vue?vue&type=template&id=8ac3169a"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormButton.vue"]])

export default __exports__